export default __webpack_public_path__ + "static/media/power-switch.ee47a6e0.svg";